import { migrations as viewMigrations } from '@/migrations/view/migrations'

export default {
  view: viewMigrations,
}
